export const hideHeader = [
  /\/account\/cleanup/,
  /\/account\/settings\/notifications\/[a-zA-Z]+/,
  /\/account\/students\/[a-z0-9]+\/profile\/edit/,
  /\/account\/agreements/,
  /\/account\/info-requests/,
  /\/admin\/agreements\/[a-z0-9]+/,
  /\/admin\/bulk-edit/,
  /\/admin\/bulk-register/,
  /\/admin\/usa-swimming/,
  /\/admin\/meets\/[a-z0-9]+\/edit/,
  /\/admin\/meets\/add/,
  /\/admin\/meets\/times\/import/,
  /\/admin\/meets\/standards\/add/,
  /\/admin\/meets\/standards\/[a-z0-9]+\/settings/,
  /\/admin\/meets\/[a-z0-9]+\/visibility/,
  /\/admin\/meets\/[a-z0-9]+\/details/,
  /\/admin\/meets\/[a-z0-9]+\/unknown-details/,
  /\/admin\/volunteers\/[a-z0-9]+\/visibility/,
  /\/admin\/volunteers\/add/,
  /\/admin\/classes\/[a-z0-9]+\/edit\/[\d]/,
  /\/admin\/custom-private-lessons\/[a-z0-9]+\/add/,
  /\/account\/custom-private-lessons\/[a-z0-9]+\/add/,
  /\/admin\/custom-private-lessons\/[a-z0-9]+\/post/,
  /\/admin\/custom-private-lessons\/[a-z0-9]+\/schedule/,
  /\/admin\/departments\/add/,
  /\/admin\/fees\/[a-z0-9]+/,
  /\/admin\/group-offerings\/[a-z0-9]+\/edit/,
  /\/admin\/group-offerings\/add/,
  /\/admin\/group-registrations\/[a-z0-9]+\/edit-info-requests/,
  /\/account\/group-registrations\/[a-z0-9]+\/edit-info-requests/,
  /\/account\/students\/[a-z0-9]+\/edit-info-requests/,
  /\/admin\/health-questions\/add/,
  /\/admin\/health-questions\/edit\/[a-z0-9]+/,
  /\/admin\/locations\/[a-z0-9]+/,
  /\/admin\/membership-offerings\/add/,
  /\/admin\/memberships\/[a-z0-9]+\/edit-info-requests/,
  /\/admin\/memberships\/[a-z0-9]+\/participant-details/,
  /\/admin\/memberships\/[a-z0-9]+\/add/,
  /\/account\/memberships\/[a-z0-9]+\/add/,
  /\/admin\/offerings\/[a-z0-9]+\/edit\/[\d]/,
  /\/admin\/offerings\/add/,
  /\/admin\/offerings\/add\/[\d]/,
  /\/admin\/pass-offerings\/add/,
  /\/admin\/passes\/add/,
  /\/admin\/private-lessons\/add/,
  /\/admin\/private-offerings\/[a-z0-9]+\/edit/,
  /\/admin\/private-offerings\/add/,
  /\/admin\/registration-restrictions/,
  /\/admin\/settings\/[a-z0-9]+\/addons\/[a-z0-9]+/,
  /\/admin\/settings\/[a-z0-9]+\/coupons\/[a-z0-9]+/,
  /\/admin\/settings\/[a-z0-9]+\/coupons\/add/,
  /\/admin\/settings\/[a-z0-9]+\/discounts\/[a-z0-9]+/,
  /\/admin\/settings\/[a-z0-9]+\/discounts\/add/,
  /\/admin\/settings\/[a-z0-9]+\/programs\/[a-z0-9]+/,
  /\/admin\/settings\/[a-z0-9]+\/student-info-requests\/[a-z0-9]+/,
  /\/admin\/settings\/[a-z0-9]+\/student-info-requests\/add/,
  /\/admin\/settings\/[a-z0-9]+\/student-info-requests\/edit\/[a-z0-9]+/,
  /\/admin\/setup\/department\/[a-z]+/,
  /\/admin\/setup\/organization\/[a-z]+/,
  /\/admin\/users\/[a-z0-9]+\/departments\/edit/,
  /\/admin\/users\/[a-z0-9]+\/edit/,
  /\/admin\/users\/[a-z0-9]+\/notifications\/[a-zA-Z]+/,
  /\/admin\/users\/[a-z0-9]+\/permissions\/edit/,
  /\/admin\/users\/[a-z0-9]+\/profile\/edit/,
  /\/admin\/users\/[a-z0-9]+\/access\/add/,
  /\/admin\/users\/add/,
  /\/admin\/users\/add\/[\d]/,
  /\/admin\/communications\/templates\/add/,
  /\/admin\/communications\/templates\/[a-z0-9]+\/edit/,
  /\/callback-stripe/,
  /\/cart/,
  /\/explore/,
  /\/message/,
  /\/edit-message/,
  /\/register/,
  /\/super-admin\/organizations\/[a-z0-9]+\/users\/add/,
  /\/super-admin\/organizations\/[a-z0-9]+\/users\/add\/[\d]/,
  /\/super-admin\/referrals\/add/,
  /\/super-admin\/referrals\/edit\/[a-z0-9]+/,
  /\/super-admin\/users\/add/,
  /\/super-admin\/organizations\/add/,
  /^\/admin\/checkout/,
  /^\/admin\/memberships\/[a-z0-9]+\/checkout/,
  /^\/account\/memberships\/[a-z0-9]+\/checkout/,
  /^\/admin\/departments\/[a-z0-9]+$/,
  /^\/checkout/,
];
